import React, { useState, useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import config from "../../config.json";

const MsgWithApplicantPopup = ({ handleAddNewMessage, onClose, handleModalShowHide, isLoading }) => {
  const fileInputRef = useRef(null);

  const [message, setMessage] = useState("");
  const [documents, setDocuments] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState("");
  const [msgType, setMsgType] = useState("");
  const [cannedMessages, setCannedMessages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  const messageTypes = [
    { id: 1, name: "Enrollment/Onboarding" },
    { id: 2, name: "ACH Information" },
    { id: 3, name: "Insurane Information" },
    { id: 4, name: "Contract" },
    { id: 5, name: "Purchase Orders" },
    { id: 6, name: "Documents" },
    { id: 7, name: "Invoices" },
    { id: 8, name: "Engagement/Termination" },
    { id: 9, name: "Contract Termination" },
    { id: 10, name: "Engagement Extention" },
    { id: 11, name: "Payments" },
    { id: 12, name: "Others" },
  ];

  // Fetch canned messages (if needed)
  useEffect(() => {
    // Example:
    // const fetchCannedMessages = async () => {
    //   const { data } = await http.get(config.GetCodemanager + "Canned Message");
    //   setCannedMessages(data);
    // };
    // fetchCannedMessages();
  }, []);

  const messgeOnFileChange = (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      const doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size // bytes
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (file) => {
    setDocuments((prevDocs) => prevDocs.filter((doc) => doc.name !== file.name));
  };

  const handleSubmit = () => {
    handleAddNewMessage(message, documents, msgType);
    setMessage("");
    setDocuments([]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map(file => ({
      name: file.name,
      type: file.type,
      size: file.size, // bytes
      file: file,
    }));
    setDocuments(prev => [...prev, ...docs]);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handleTemplateChange = (e) => {
    setTemplateId(e.target.value);
  };

  const handleCannedMessage = (e) => {
    setMessage(e.target.value);
  };

  return (
    <div className="modern-popup-container">
      <style>{`
        :root {
          --primary-color: #2563eb;
          --primary-hover: #1d4ed8;
          --primary-soft: #eff6ff;
          --secondary-color: #64748b;
          --secondary-hover: #475569;
          --border-color: #e2e8f0;
          --bg-light: #f8fafc;
          --text-main: #1e293b;
          --text-muted: #64748b;
          --radius-md: 10px;
          --radius-sm: 8px;
          --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        }

        .modern-popup-container {
          padding: 10px;
          color: var(--text-main);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        .section-label {
          font-size: 13px;
          font-weight: 600;
          color: var(--text-muted);
          text-transform: uppercase;
          letter-spacing: 0.025em;
          margin-bottom: 12px;
          display: block;
        }

        .drop-zone {
          border: 2px dashed var(--border-color);
          border-radius: 0 !important;
          background: var(--bg-light);
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 140px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .drop-zone:hover {
          border-color: var(--primary-color);
          background: var(--primary-soft);
        }

        .drop-zone.dragging {
          border-color: var(--primary-color);
          background: var(--primary-soft);
          transform: scale(1.01);
        }

        .drop-zone i {
          color: var(--primary-color);
          font-size: 2rem;
          margin-bottom: 0.75rem;
          transition: transform 0.2s;
        }

        .drop-zone:hover i {
          transform: translateY(-4px);
        }

        .drop-zone p {
          font-size: 14px;
          color: var(--text-main);
          font-weight: 500;
          margin: 0;
        }

        .drop-zone span {
          font-size: 12px;
          color: var(--text-muted);
          margin-top: 4px;
        }

        .file-preview-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
          gap: 12px;
          margin: 20px 0;
        }

        .file-card {
          background: #fff;
          border: 1px solid var(--border-color);
          border-radius: var(--radius-sm);
          padding: 10px 12px;
          display: flex;
          align-items: center;
          gap: 12px;
          box-shadow: var(--shadow-sm);
          transition: all 0.2s;
          position: relative;
        }

        .file-card:hover {
          border-color: var(--primary-color);
          box-shadow: var(--shadow-md);
          transform: translateY(-2px);
        }

        .file-icon-wrapper {
          width: 38px;
          height: 38px;
          background: var(--primary-soft);
          color: var(--primary-color);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          font-size: 16px;
          flex-shrink: 0;
        }

        .file-content {
          flex: 1;
          min-width: 0;
        }

        .file-title {
          font-size: 13px;
          font-weight: 600;
          color: var(--text-main);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 2px;
        }

        .file-meta {
          font-size: 11px;
          color: var(--text-muted);
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .btn-remove-file {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: none;
          background: transparent;
          color: var(--text-muted);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
          flex-shrink: 0;
        }

        .btn-remove-file:hover {
          background: #fee2e2;
          color: #dc2626;
        }

        .form-field-group {
          margin-bottom: 20px;
        }

        .form-label {
          font-size: 13px;
          font-weight: 600;
          color: var(--text-main);
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .modern-select, .modern-textarea {
          width: 100%;
          border: 1px solid var(--border-color);
          border-radius: var(--radius-sm);
          padding: 10px 14px;
          font-size: 14px;
          transition: all 0.2s;
          background-color: #fff;
          color: var(--text-main);
        }

        .modern-select:focus, .modern-textarea:focus {
          outline: none;
          border-color: var(--primary-color);
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.08);
        }

        .modern-textarea {
          resize: vertical;
          min-height: 100px;
        }

        .wf-popup-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid var(--border-color);
        }

        .wf-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          width: auto !important;
          height: auto !important;
          min-width: unset !important;
          min-height: unset !important;
          padding: 7px 14px !important;
          border: 1px solid transparent !important;
          border-radius: 0 !important;
          box-sizing: border-box !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          line-height: 1.25 !important;
          letter-spacing: 0.01em !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .wf-btn-primary {
          background: #2563eb !important;
          border-color: #2563eb !important;
          color: #ffffff !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }

        .wf-btn-primary:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }

        .wf-btn-secondary {
          background: #ffffff !important;
          color: #1e293b !important;
          border-color: #cbd5e1 !important;
        }

        .wf-btn-secondary:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .wf-btn i {
          font-size: 13px !important;
        }
      `}</style>
      <div className="row">
        <div className="col-12">
          <label className="section-label">Attachments</label>
          <div
            className={`drop-zone ${isDragging ? "dragging" : ""}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current.click()}
          >
            <i className="fa fa-cloud-upload" aria-hidden="true"></i>
            <p>Drag & drop files here</p>
            <span>or click to browse from your computer</span>
          </div>
        </div>
      </div>

      {documents.length > 0 && (
        <div className="file-preview-grid">
          {documents.map((file, index) => (
            <div key={index} className="file-card">
              <div className="file-icon-wrapper">
                <i
                  className={`fa ${file.type?.includes("image")
                      ? "fa-file-image-o"
                      : file.type?.includes("pdf")
                        ? "fa-file-pdf-o"
                        : "fa-file-text-o"
                    }`}
                  aria-hidden="true"
                ></i>
              </div>
              <div className="file-content">
                <div className="file-title" title={file.name}>
                  {file.name}
                </div>
                <div className="file-meta">
                  <span>{formatFileSize(file.size)}</span>
                </div>
              </div>
              <button
                className="btn-remove-file"
                onClick={(e) => {
                  e.stopPropagation();
                  handleFileRemove(file);
                }}
                title="Remove file"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="row mt-4">
        <div className="col-12 form-field-group">
          <label htmlFor="msgType" className="form-label">
            Message Type
          </label>
          <select
            name="msgType"
            id="msgType"
            className="modern-select"
            value={msgType}
            onChange={(e) => setMsgType(e.target.value)}
          >
            <option value="">Select a message type...</option>
            {messageTypes.map((type) => (
              <option key={type.id} value={type.name}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-12 form-field-group">
          <label htmlFor="message" className="form-label">
            Message Content
          </label>
          <textarea
            name="message"
            id="message"
            className="modern-textarea"
            placeholder="Type your message here..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </div>
      </div>

      <div className="wf-popup-footer">
        <button
          className="wf-btn wf-btn-secondary"
          onClick={() => {
            if (onClose) onClose();
            else if (handleModalShowHide) handleModalShowHide();
          }}
          type="button"
          disabled={isLoading}
        >
          <i className="fa fa-arrow-left" aria-hidden="true" />
          Back
        </button>
        <button
          className="wf-btn wf-btn-primary"
          onClick={handleSubmit}
          type="button"
          disabled={isLoading || (!message.trim() && documents.length === 0)}
        >
          {isLoading ? (
            <>
              <i className="fa fa-spinner fa-spin" aria-hidden="true" />
              Sending...
            </>
          ) : (
            <>
              <i className="fa fa-paper-plane" aria-hidden="true" />
              Send Message
            </>
          )}
        </button>
      </div>

      <input
        type="file"
        ref={fileInputRef}
        onChange={messgeOnFileChange}
        multiple
        style={{ display: "none" }}
      />
    </div>
  );
};

export default MsgWithApplicantPopup;
